import 'slick-carousel';

export default {
    when() {
        return document.querySelectorAll('.slick').length > 0;
    },

    mounted() {
        document.querySelectorAll('.slick').forEach((element) => {
            $('.slick').slick({
                centerMode: false,
                slidesToShow: 3,
                prevArrow: '<div class="z-40 cursor-pointer prev-arrow absolute -bottom-[54px] md:-bottom-[40px] right-[77px] md:right-[60px]"><img src="/app/themes/cherrypulp/resources/images/slick-arrow-left.svg" alt="">	</div>',
                nextArrow: '<div class="z-40 cursor-pointer next-arrow absolute -bottom-[54px] md:-bottom-[40px] right-[20px] md:right-0"><img src="/app/themes/cherrypulp/resources/images/slick-arrow-right.svg" alt="">	</div>',
                // prevArrow: '<a class="prev-arrow" style="background-image: url(/app/themes/cherrypulp/resources/images/→-2.svg)"></a>',
                arrows: true,
                infinite: false,

                responsive: [
                    {
                        breakpoint: 600,
                        settings: {
                            centerPadding: '0px',
                            infinite: true,
                            slidesToShow: 1,
                        },
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            centerPadding: '0px',
                            infinite: true,
                            slidesToShow: 2,
                        },
                    },
                ],
            });
            $('.slick').on('setPosition', function () {
                $(this).find('.slick-slide').height('auto');
                var slickTrack = $(this).find('.slick-track');
                var slickTrackHeight = $(slickTrack).height();
                $(this).find('.slick-slide').css('height', slickTrackHeight + 'px');
            });
        });
    },
};
